export default "__VITE_ASSET__BdNmrrqG__"